import React from 'react';

export const SvgIconAssistant = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.9316 9.90169C11.205 10.6812 11.8182 11.2943 12.5977 11.5677L15.2568 12.4993L12.5977 13.432C11.8181 13.7053 11.205 14.3184 10.9316 15.098L9.99902 17.7562L9.06738 15.098C8.79399 14.3185 8.18088 13.7053 7.40137 13.432L4.74219 12.4993L7.40137 11.5677C8.18094 11.2943 8.79402 10.6813 9.06738 9.90169L9.99902 7.24348L10.9316 9.90169Z'
        stroke='currentColor'
        strokeWidth='1.49996'
      />
      <path
        d='M3.54056 4.4632C3.55901 4.41059 3.60867 4.37538 3.66442 4.37538H3.83543C3.89117 4.37538 3.94084 4.41059 3.95928 4.4632L4.40587 5.73681C4.48505 5.96262 4.66261 6.14018 4.88842 6.21935L6.16203 6.66595C6.21463 6.68439 6.24985 6.73405 6.24985 6.7898V6.96081C6.24985 7.01656 6.21463 7.06622 6.16203 7.08466L4.88842 7.53126C4.66261 7.61043 4.48505 7.78799 4.40587 8.0138L3.95928 9.28741C3.94084 9.34002 3.89117 9.37523 3.83543 9.37523H3.66442C3.60867 9.37523 3.55901 9.34002 3.54056 9.28741L3.09397 8.0138C3.01479 7.78799 2.83724 7.61043 2.61143 7.53126L1.33782 7.08466C1.28521 7.06622 1.25 7.01656 1.25 6.96081V6.7898C1.25 6.73405 1.28521 6.68439 1.33782 6.66595L2.61143 6.21935C2.83724 6.14018 3.01479 5.96262 3.09397 5.73681L3.54056 4.4632Z'
        fill='currentColor'
      />
      <path
        d='M15.3709 1.33827C15.3894 1.28566 15.439 1.25045 15.4948 1.25045H15.7551C15.8108 1.25045 15.8605 1.28566 15.8789 1.33827L16.4762 3.04155C16.5553 3.26736 16.7329 3.44492 16.9587 3.5241L18.662 4.12135C18.7146 4.1398 18.7498 4.18946 18.7498 4.24521V4.5055C18.7498 4.56125 18.7146 4.61091 18.662 4.62936L16.9587 5.22661C16.7329 5.30579 16.5553 5.48335 16.4762 5.70916L15.8789 7.41244C15.8605 7.46505 15.8108 7.50026 15.7551 7.50026H15.4948C15.439 7.50026 15.3894 7.46505 15.3709 7.41244L14.7736 5.70916C14.6945 5.48335 14.5169 5.30579 14.2911 5.22661L12.5878 4.62936C12.5352 4.61091 12.5 4.56125 12.5 4.5055V4.24521C12.5 4.18946 12.5352 4.1398 12.5878 4.12135L14.2911 3.5241C14.5169 3.44492 14.6945 3.26736 14.7736 3.04155L15.3709 1.33827Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const SvgIconCreate = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_2251_10604'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='1'
        y='1'
        width='18'
        height='18'>
        <path
          d='M10.7766 6.89366C10.4417 6.80994 10.1024 7.01354 10.0187 7.34841L8.76866 12.3484C8.68494 12.6833 8.88854 13.0226 9.22342 13.1063C9.55829 13.1901 9.89762 12.9865 9.98134 12.6516L11.2313 7.65158C11.3151 7.31671 11.1115 6.97737 10.7766 6.89366Z'
          fill='currentColor'
        />
        <path
          d='M7.94194 7.94193C8.18602 7.69785 8.18602 7.30213 7.94194 7.05805C7.69786 6.81397 7.30214 6.81397 7.05806 7.05805L4.55806 9.55805C4.31398 9.80213 4.31398 10.1979 4.55806 10.4419L7.05806 12.9419C7.30214 13.186 7.69786 13.186 7.94194 12.9419C8.18602 12.6979 8.18602 12.3021 7.94194 12.058L5.88388 9.99999L7.94194 7.94193Z'
          fill='currentColor'
        />
        <path
          d='M12.0581 7.94193C11.814 7.69785 11.814 7.30213 12.0581 7.05805C12.3021 6.81397 12.6979 6.81397 12.9419 7.05805L15.4419 9.55805C15.686 9.80213 15.686 10.1979 15.4419 10.4419L12.9419 12.9419C12.6979 13.186 12.3021 13.186 12.0581 12.9419C11.814 12.6979 11.814 12.3021 12.0581 12.058L14.1161 9.99999L12.0581 7.94193Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.875 3.125C1.875 2.43464 2.43464 1.875 3.125 1.875H16.875C17.5654 1.875 18.125 2.43464 18.125 3.125V16.875C18.125 17.5654 17.5654 18.125 16.875 18.125H3.125C2.43464 18.125 1.875 17.5654 1.875 16.875V3.125ZM3.125 3.125H16.875V16.875H3.125L3.125 3.125Z'
          fill='currentColor'
        />
      </mask>
      <g mask='url(#mask0_2251_10604)'>
        <rect width='20' height='20' fill='currentColor' />
      </g>
    </svg>
  );
};

export const SvgIconDocumentation = () => {
  return (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_2251_10595'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='2'
        y='1'
        width='16'
        height='19'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.75 1.75C3.05964 1.75 2.5 2.30965 2.5 3V18C2.5 18.6904 3.05964 19.25 3.75 19.25H16.25C16.9404 19.25 17.5 18.6904 17.5 18V8.25888C17.5 7.92736 17.3683 7.60942 17.1339 7.375L11.875 2.11612C11.6406 1.8817 11.3226 1.75 10.9911 1.75H3.75ZM10 3L3.75 3V18H16.25V9.25H11.25C10.5596 9.25 10 8.69036 10 8V3ZM15.9911 8L11.25 3.25888V8H15.9911Z'
          fill='currentColor'
        />
      </mask>
      <g mask='url(#mask0_2251_10595)'>
        <rect y='0.5' width='20' height='20' fill='currentColor' />
      </g>
    </svg>
  );
};

export const SvgIconKeyboardReturn = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.2502 5.83382V9.16715H5.27516L8.2585 6.17549L7.0835 5.00049L2.0835 10.0005L7.0835 15.0005L8.2585 13.8255L5.27516 10.8338H17.9168V5.83382H16.2502Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const SvgIconLargePartBlock = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.97625 5.32135C3.768 5.44159 3.76789 5.74213 3.97605 5.86251L9.68843 9.16608C9.88215 9.27812 10.121 9.27803 10.3146 9.16584L16.0195 5.86076C16.2274 5.74027 16.2272 5.4399 16.0191 5.31972L10.3116 2.0245C10.1182 1.91285 9.87994 1.91285 9.68657 2.0245L3.97625 5.32135ZM17.1158 7.21242C17.1158 6.97165 16.855 6.82133 16.6467 6.94202L10.9358 10.2506C10.7429 10.3624 10.6241 10.5684 10.6241 10.7914V17.3774C10.6241 17.6179 10.8845 17.7683 11.0929 17.648L16.8033 14.3511C16.9967 14.2394 17.1158 14.0331 17.1158 13.8098V7.21242ZM8.90535 17.648C9.11369 17.7683 9.3741 17.618 9.3741 17.3774V10.7888C9.3741 10.5657 9.25515 10.3595 9.062 10.2478L3.35127 6.94517C3.14294 6.82468 2.88232 6.97502 2.88232 7.21569V13.8098C2.88232 14.0331 3.00145 14.2394 3.19482 14.3511L8.90535 17.648ZM10.9366 0.941968C10.3564 0.607031 9.64169 0.607031 9.06157 0.941968L2.56982 4.68998C1.9897 5.02491 1.63232 5.6439 1.63232 6.31378V13.8098C1.63232 14.4797 1.9897 15.0987 2.56982 15.4336L9.06157 19.1816C9.64169 19.5165 10.3564 19.5165 10.9366 19.1816L17.4283 15.4336C18.0084 15.0987 18.3658 14.4797 18.3658 13.8098V6.31378C18.3658 5.6439 18.0084 5.02491 17.4283 4.68998L10.9366 0.941968Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const SvgIconList = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_2251_10535'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='2'
        y='4'
        width='16'
        height='12'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.50024 5.00005C7.50024 4.65487 7.75854 4.37505 8.07717 4.37505H16.9233C17.242 4.37505 17.5002 4.65487 17.5002 5.00005C17.5002 5.34523 17.242 5.62505 16.9233 5.62505H8.07717C7.75854 5.62505 7.50024 5.34523 7.50024 5.00005Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.50024 10.0001C7.50024 9.65487 7.75854 9.37505 8.07717 9.37505H16.9233C17.242 9.37505 17.5002 9.65487 17.5002 10.0001C17.5002 10.3452 17.242 10.6251 16.9233 10.6251H8.07717C7.75854 10.6251 7.50024 10.3452 7.50024 10.0001Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.50024 15.0001C7.50024 14.6549 7.75854 14.3751 8.07717 14.3751H16.9233C17.242 14.3751 17.5002 14.6549 17.5002 15.0001C17.5002 15.3452 17.242 15.6251 16.9233 15.6251H8.07717C7.75854 15.6251 7.50024 15.3452 7.50024 15.0001Z'
          fill='currentColor'
        />
        <path
          d='M4.16691 5.00005C4.16691 5.46029 3.79381 5.83338 3.33358 5.83338C2.87334 5.83338 2.50024 5.46029 2.50024 5.00005C2.50024 4.53981 2.87334 4.16672 3.33358 4.16672C3.79381 4.16672 4.16691 4.53981 4.16691 5.00005Z'
          fill='currentColor'
        />
        <path
          d='M4.16691 10.0001C4.16691 10.4603 3.79381 10.8334 3.33358 10.8334C2.87334 10.8334 2.50024 10.4603 2.50024 10.0001C2.50024 9.53981 2.87334 9.16672 3.33358 9.16672C3.79381 9.16672 4.16691 9.53981 4.16691 10.0001Z'
          fill='currentColor'
        />
        <path
          d='M4.16691 15.0001C4.16691 15.4603 3.79381 15.8334 3.33358 15.8334C2.87334 15.8334 2.50024 15.4603 2.50024 15.0001C2.50024 14.5398 2.87334 14.1667 3.33358 14.1667C3.79381 14.1667 4.16691 14.5398 4.16691 15.0001Z'
          fill='currentColor'
        />
      </mask>
      <g mask='url(#mask0_2251_10535)'>
        <rect width='20' height='20' fill='currentColor' />
      </g>
    </svg>
  );
};

export const SvgIconPlayCircleOutlineFilled = () => {
  return (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.33342 14.25L13.3334 10.5L8.33342 6.75V14.25ZM10.0001 2.16666C5.40008 2.16666 1.66675 5.9 1.66675 10.5C1.66675 15.1 5.40008 18.8333 10.0001 18.8333C14.6001 18.8333 18.3334 15.1 18.3334 10.5C18.3334 5.9 14.6001 2.16666 10.0001 2.16666ZM10.0001 17.1667C6.32508 17.1667 3.33341 14.175 3.33341 10.5C3.33341 6.825 6.32508 3.83333 10.0001 3.83333C13.6751 3.83333 16.6667 6.825 16.6667 10.5C16.6667 14.175 13.6751 17.1667 10.0001 17.1667Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const SvgIconSearch = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_2251_10627'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='2'
        y='2'
        width='17'
        height='17'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.37479 2.49931C5.57795 2.49931 2.5 5.57726 2.5 9.3741C2.5 13.1709 5.57795 16.2489 9.37479 16.2489C11.0393 16.2489 12.5656 15.6574 13.755 14.6731L16.3853 17.8878C16.5075 18.0372 16.6904 18.1238 16.8834 18.1238C17.5689 18.1238 18.1245 17.5682 18.1245 16.8827C18.1245 16.6897 18.0379 16.5068 17.8885 16.3846L14.6737 13.7543C15.658 12.5649 16.2496 11.0386 16.2496 9.3741C16.2496 5.57726 13.1716 2.49931 9.37479 2.49931ZM3.74996 9.3741C3.74996 6.2676 6.26828 3.74928 9.37479 3.74928C12.4813 3.74928 14.9996 6.2676 14.9996 9.3741C14.9996 12.4806 12.4813 14.9989 9.37479 14.9989C6.26828 14.9989 3.74996 12.4806 3.74996 9.3741Z'
          fill='currentColor'
        />
      </mask>
      <g mask='url(#mask0_2251_10627)'>
        <rect y='-0.000610352' width='19.9994' height='19.9994' fill='currentColor' />
      </g>
    </svg>
  );
};
